// Design tokens for the student panel -- a "campus" palette built for an
// energetic but credible student-facing product. Primary color / dark-mode
// stay user-configurable (see ThemeSettingsContext); everything else is
// fixed so the product keeps a consistent identity regardless of the
// chosen brand color.

export const tokens = {
  ink: '#1B1B2F',        // near-black text, warmer than pure black
  inkSoft: '#5B5B76',    // secondary text
  cloud: '#F6F5FC',      // app background, faint lavender-white
  cloudDark: '#12121D',  // app background in dark mode
  surfaceDark: '#191927',
  mint: '#1FBE93',       // present / success / positive
  mintSoft: '#E3FBF3',
  coral: '#FF6B6B',      // absent / error / negative
  coralSoft: '#FFECEC',
  amber: '#FFB020',      // pending / streaks / highlights
  amberSoft: '#FFF4DE',
  indigo: '#5B5FEF',     // default brand / primary
  violetDeep: '#3E3BAA', // gradient partner for hero
  ring: 'rgba(91,95,239,0.35)',
};

export const fontStack = {
  display: '"Sora", "Segoe UI", sans-serif',
  body: '"Inter", "Segoe UI", sans-serif',
};

export const fontImport =
  '@import url(\'https://fonts.googleapis.com/css2?family=Sora:wght@500;600;700;800&family=Inter:wght@400;500;600;700&display=swap\');';
